// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","player":"App_player__1wNcv","dragArea":"App_dragArea__2tjDW"};